import { lazy, Suspense } from "react";

import { cn } from "@/utils/shadcn-ui";

import type { RichTextEditorProps } from "./rich-text-editor";

import { Spinner } from "./spinner";

const RichTextEditor = lazy(() =>
  import("./rich-text-editor").then((m) => ({ default: m.RichTextEditor })),
);

export function LazyRichTextEditor(props: RichTextEditorProps) {
  const hasMinHeight = /(?:^|\s)min-h-/.test(props.className ?? "");
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            "border-input bg-muted/30 flex w-full items-center justify-center rounded-md border",
            !hasMinHeight && "min-h-16",
            props.className,
          )}
        >
          <Spinner size={24} />
        </div>
      }
    >
      <RichTextEditor {...props} />
    </Suspense>
  );
}
